export default class RoutesUtils {
    static getItemsWithOrder = (items: Array<any>) => {
        return items.map((item, i) => {
            item.order = i
            return item
        })
    }
}
